<h1 mat-dialog-title>Asignar raqueta final</h1>
<div mat-dialog-content>
  <p class="dialog-assisted-bid-assign__hint">
    La puja del lote <strong>{{ data.lotId }}</strong> quedó registrada bajo
    <strong>{{ data.racketName }}</strong>. Busque y seleccione el usuario final al que debe adjudicarse.
  </p>

  <mat-form-field class="dialog-assisted-bid-assign__search" appearance="fill">
    <mat-label>Buscar usuario</mat-label>
    <input
      matInput
      [formControl]="searchControl"
      [matAutocomplete]="userAutocomplete"
      placeholder="Nombre o raqueta"
    />
    <mat-autocomplete
      #userAutocomplete="matAutocomplete"
      [displayWith]="displayUser"
      (optionSelected)="onUserSelected($event.option.value)"
    >
      <mat-option *ngFor="let user of filteredUsers" [value]="user">
        {{ user.client }} - {{ user.username }}
      </mat-option>
    </mat-autocomplete>
    <mat-hint *ngIf="isSearching">Buscando...</mat-hint>
  </mat-form-field>

  <p *ngIf="selectedUser" class="dialog-assisted-bid-assign__selected">
    Seleccionado: <strong>{{ selectedUser.client }} - {{ selectedUser.username }}</strong>
  </p>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancelar</button>
  <button mat-raised-button color="primary" [disabled]="!selectedUser" (click)="onConfirm()">
    Confirmar
  </button>
</div>
